module.exports = __webpack_public_path__ + "img/home-nav-icon-5.6fa5ad14.png";